import { render, staticRenderFns } from "./_Card.vue?vue&type=template&id=0125d6ce&scoped=true&"
import script from "./_Card.vue?vue&type=script&lang=js&"
export * from "./_Card.vue?vue&type=script&lang=js&"
import style0 from "./_Card.vue?vue&type=style&index=0&id=0125d6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125d6ce",
  null
  
)

export default component.exports